import { formatCurrency } from '@/utils/currency';
import { toTitleCase } from '@/utils/kyc';
import { MODULE_ICONS } from '@/constants/icons';

const PURCHASE_SOURCE_LABELS_PT: Record<string, string> = {
  direct: 'Portal',
  kyx: 'KYX',
  kyt: 'KYT',
  pulse: 'Pulse',
};

const PURCHASE_SOURCE_ICONS: Record<string, string> = {
  direct: 'shopping_bag',
  kyx: MODULE_ICONS.kyx,
  kyt: MODULE_ICONS.kyt,
  pulse: MODULE_ICONS.pulse,
};

const PURCHASE_SOURCE_BADGE_CLASS: Record<string, string> = {
  direct: 'border-amber-300/70 bg-amber-100/80 text-amber-950',
  kyx: 'border-cyan-300/70 bg-cyan-100/80 text-cyan-950',
  kyt: 'border-emerald-300/70 bg-emerald-100/80 text-emerald-950',
  pulse: 'border-rose-300/70 bg-rose-100/80 text-rose-950',
};

export const getPurchaseSourceLabel = (purchaseSource: string) => {
  return PURCHASE_SOURCE_LABELS_PT[purchaseSource] || toTitleCase(purchaseSource);
};

export const getPurchaseSourceIcon = (purchaseSource: string) => {
  return PURCHASE_SOURCE_ICONS[purchaseSource] || 'shopping_bag';
};

export const getPurchaseSourceBadgeClass = (purchaseSource: string) => {
  return PURCHASE_SOURCE_BADGE_CLASS[purchaseSource] || 'border-slate-300/70 bg-slate-100/80 text-slate-900';
};

export const formatBilledAmount = (amount: number, currency: string) => {
  return formatCurrency(amount, currency, false);
};

export const getTokenChargeSourceTooltip = (isPayg: boolean) =>
  isPayg
    ? 'Cobrado como pay-as-you-go — consumo além do pacote incluído'
    : 'Debitado do pacote de tokens incluído na assinatura';

export const getTokenChargeSourceIcon = (isPayg: boolean) =>
  isPayg ? 'electric_bolt' : 'inventory_2';

export const getTokenChargeSourceBadgeClass = (isPayg: boolean) =>
  isPayg ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700';

export const formatTokenUsageAmount = (amount: number) => `-${amount.toLocaleString('pt-BR')}`;
